import { Component, inject, Input as RouterInput, ViewChild } from '@angular/core';
import { getIdToken } from '@angular/fire/auth';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BaseComponent } from '../../shared/base.component';
import { UpdateDealerRepState } from '../../shared/state-interface';
import { SiteHeaderComponent } from '../../site-header/site-header.component';
import { DealerRepComponent } from '../shared/dealer-rep.component';
import { DealerRep } from '../shared/dealer-rep.model';
import { DealerRepService } from '../shared/dealer-rep.service';

@Component({
    selector: 'app-update-dealer-rep',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        MatInputModule,
        MatButtonModule,
        SiteHeaderComponent,
        DealerRepComponent
    ],
    templateUrl: './update-dealer-rep.component.html',
    styleUrl: './update-dealer-rep.component.css'
})
export class UpdateDealerRepComponent extends BaseComponent {

    @RouterInput() id: number = -1;
    @ViewChild(DealerRepComponent) dealerRepComponent!:DealerRepComponent;

    private dealerRepService: DealerRepService = inject(DealerRepService);

    private static _retrievingDealerRep = "Retrieving Dealer Rep";
    private static _retrievingDealerRepError = `${UpdateDealerRepComponent._retrievingDealerRep} error:`;
    private static _updatingDealerRep = "Updating Dealer Rep";
    private static _updatingDealerRepError = `${UpdateDealerRepComponent._updatingDealerRep} error:`;

    private _dealerRep: DealerRep = new DealerRep();

    public ngAfterViewInit() {
        const state: UpdateDealerRepState | undefined = this.stateManager.updateDealerRepState;
        
        if (state != undefined) {
            this._dealerRep = state.dealerRep;
            this.dealerRepComponent.restoreState(state.dealerRepComponentState);
            super.restoreState(state.baseComponentState);
        } else {
            this.loadDealerRep(this.id);
        }
    }

    public ngOnDestroy() {
        const state:UpdateDealerRepState = {} as UpdateDealerRepState;
        state.dealerRep = this._dealerRep;
        state.dealerRepComponentState = this.dealerRepComponent.getState();
        state.baseComponentState = super.getState();
        this.stateManager.updateDealerRepState = state;
    }

    protected async loadDealerRep(id: number) {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            const observable = await this.dealerRepService.getDealerRep(await getIdToken(currentUser), id);
            this.message = "";
            super.showSnackBar(`${UpdateDealerRepComponent._retrievingDealerRep}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["get-dealer-rep"] == "success") {
                        // Convert generic JSON object to type of DealerRep.
                        this._dealerRep = DealerRep.toDealerRep(json["dealer-rep"]);
                        this.dealerRepComponent.populateFormFromModel(this._dealerRep);
                        this.message = "";
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${UpdateDealerRepComponent._retrievingDealerRepError} ${(<Error>error).message}`;
                    this.message = message;
                }
                super.dismissSnackBar();
            })
        }
    }

    protected cancel() {
        this.router.navigate(["/view-dealer-reps"], { state: { restore: true } });
    }

    protected async save() {
        const currentUser = this.auth.currentUser;

        if (currentUser) {
            this._dealerRep = this.dealerRepComponent.createModelFromForm(this._dealerRep);

            const observable = await this.dealerRepService.updateDealerRep(await getIdToken(currentUser), this._dealerRep);
            this.message = "";
            super.showSnackBar(`${UpdateDealerRepComponent._updatingDealerRep}...`, -1);

            observable.subscribe(response => {
                try {
                    const json = JSON.parse(JSON.stringify(response));
                    if (json["update-dealer-rep"] == "success") {
                        const queryParam = `Dealer Rep '${this._dealerRep.first_name} ${this._dealerRep.last_name}' updated.`;
                        this.router.navigate(["/view-dealer-reps"], { queryParams: {"overrideSnackBar": queryParam}, state: { refresh: true } });
                    } else {
                        throw new Error(json["message"]);
                    }
                } catch (error) {
                    const message = `${UpdateDealerRepComponent._updatingDealerRepError} ${(<Error>error).message}`;
                    this.message = message;
                    super.dismissSnackBar();
                }
            })
        } else {
            const message = `${UpdateDealerRepComponent._updatingDealerRepError} Null user instance`;
            console.error(message)
            super.showSnackBar(message, 30);
        }
    }
}